module.exports = __webpack_public_path__ + "img/recruit.b5dde682.jpg";